<template>
	<div>
		<Breadcrumbs main="freight.resource" title="freight.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid">
            <div>
                <div v-show="process === 'add'" class="row ">
                    <div id="addFght" class="col-sm-12 gradient-wy">
                        
                        <div class="row col-sm-8 mx-1">
                            <div class="row ml-3" v-b-hover="handleHover">
                                <h2 class="text-primary mt-3">{{ $t('freight.add') }}</h2>
                                <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="clickCancelProcess">&times;</span>
                                <span v-show="isHovered" class="text-danger">{{ $t('freight.cancelReturn')  }} </span>
                            </div>
                            <div class="row ml-5">
                                <h3 class="mt-4 text-dark">{{ $t('bookingId.agent') }} :</h3>
                                <h3 class="mt-4 ml-2 text-info"> {{ this.selectedAgent }}</h3>
                            </div>
                        </div>
                        <form class="theme-form">
                            <div class="ml-2"> 
                                <div class="row col-sm-12">
                                    <div class="col-sm-1">
                                        <label for="selectedFghtCat" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("freight.fghtCat") }}</label>                                                                       
                                        <b-form-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedFghtCat" 
                                            :options="fghtOptions" 
                                        >                            
                                        </b-form-select>
                                    </div> 
                                    <div class="col-sm-2" role="group">
                                        <label for="sctCode" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("freight.sctCode") }}</label>
                                        <b-form-input
                                            id="sctCode"
                                            style="font-size:16px;" 
                                            v-model="sctCode"
                                            type="text"
                                            :formatter="formatter"
                                            aria-describedby="input-live-help-sctCode"
                                            :placeholder="$t('freight.sctCodePh')"
                                        >
                                        </b-form-input>
                                        <b-form-text id="input-live-help-sctCode">{{ $t("freight.sctCodeHelp") }}</b-form-text>           
                                    </div>  
                                    <div class="col-sm-1 mt-1">
                                        <label for="effDate" class="f-w-600 text-primary" style="font-size: 16px">{{ $t("freight.effDate") }}</label>
                                        <datepicker input-class="datepicker-here form-control digits bg-white" :format="format" v-model="effDate" ></datepicker>
                                    </div>  
                                    <div class="col-sm-1 mt-1">
                                        <label for="expDate" class="f-w-600 text-primary" style="font-size: 16px">{{ $t("freight.expDate") }}</label>
                                        <datepicker input-class="datepicker-here form-control digits bg-white"  :disabled-dates="disabledDates"  :format="format" v-model="expDate" ></datepicker>
                                    </div>
                                    <div class="col-sm-3">
                                        <label for="selectedPOL" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("getQuote.POL") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedPOL"
                                            :reduce="text => text.value"
                                            label = 'text'
                                            :options="POLList" 
                                            :placeholder="$t('surcharge.plsSelect')"
                                        >                                     
                                        </v-select>
                                    </div> 
                                    <div class="col-sm-3">
                                        <label for="selectedPOD" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("getQuote.POD") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedPOD"
                                            :options="PODList"                                             
                                            :reduce="text => text.value"
                                            label = "text"
                                            :placeholder="$t('surcharge.plsSelect')"
                                        >     
                                        </v-select>
                                        
                                    </div>                             
                                </div>
                                <div class="row col-sm-12 mt-2">
                                    <div class="row mx-1 col-sm-1">
                                            <label for="selectedCurr" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("freight.currency") }}</label>                                                                       
                                            <b-form-select 
                                                class="style-chooser" 
                                                style="font-size:16px;" 
                                                v-model="selectedCurr" 
                                                :options="currencies" 
                                            >                            
                                            </b-form-select>
                                    </div>
                                    <div class="row mx-3">

                                        <div role="group" v-b-popover.hover.top="$t('freight.L20Details')">
                                            <label for="L20" class="col-form-label pt-0 f-w-600">{{$t("freight.L20") }}</label>
                                            <b-form-input 
                                                id="L20"
                                                style="font-size:16px;" 
                                                v-model="L20"  
                                                type="number" 
                                                :state="L20State"
                                                aria-describedby="input-live-feedback-L20"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L20"> {{`${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                      
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40Details')">
                                            <label for="L40" class="col-form-label pt-0 f-w-600">{{$t("freight.L40") }}</label>
                                            <b-form-input 
                                                id="L40"
                                                style="font-size:16px;" 
                                                v-model="L40"  
                                                type="number" 
                                                :state="L40State"
                                                aria-describedby="input-live-feedback-L40"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40"> {{`${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                             
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40HCDetails')">
                                            <label for="L40HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L40HC") }}</label>
                                            <b-form-input 
                                                id="L40HC"
                                                style="font-size:16px;" 
                                                v-model="L40HC"  
                                                type="number" 
                                                :state="L40HCState"
                                                aria-describedby="input-live-feedback-L40HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                     
                                        </div>

                                    </div>
                                    <div class="row mx-3">
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40HRDetails')">
                                            <label for="L40HR" class="col-form-label pt-0 f-w-600">{{$t("freight.L40HR") }}</label>
                                            <b-form-input 
                                                id="L40HR"
                                                style="font-size:16px;" 
                                                v-model="L40HR"  
                                                type="number" 
                                                :state="L40HRState"
                                                aria-describedby="input-live-feedback-L40HR"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40HR"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                              
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40NORDetails')">
                                            <label for="L40NOR" class="col-form-label pt-0 f-w-600">{{$t("freight.L40NOR") }}</label>
                                            <b-form-input 
                                                id="L40NOR"
                                                style="font-size:16px;" 
                                                v-model="L40NOR"  
                                                type="number" 
                                                :state="L40NORState"
                                                aria-describedby="input-live-feedback-L40NOR"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40NOR"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                               
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L20NORDetails')">
                                            <label for="L20NOR" class="col-form-label pt-0 f-w-600">{{$t("freight.L20NOR") }}</label>
                                            <b-form-input 
                                                id="L20NOR"
                                                style="font-size:16px;" 
                                                v-model="L20NOR"  
                                                type="number" 
                                                :state="L20NORState"
                                                aria-describedby="input-live-feedback-L20NOR"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L20NOR"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}`}}</b-form-invalid-feedback>                               
                                        </div>
                                    </div> 
                                    <div class="row mx-3">
                                        <div role="group" v-b-popover.hover.top="$t('freight.L20HCDetails')">
                                            <label for="L20HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L20HC") }}</label>
                                            <b-form-input 
                                                id="L20HC"
                                                style="font-size:16px;" 
                                                v-model="L20HC"  
                                                type="number" 
                                                :state="L20HCState"
                                                aria-describedby="input-live-feedback-L20HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L20HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                              
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L45Details')">
                                            <label for="L45" class="col-form-label pt-0 f-w-600">{{$t("freight.L45") }}</label>
                                            <b-form-input 
                                                id="L45"
                                                style="font-size:16px;" 
                                                v-model="L45"  
                                                type="number" 
                                                :state="L45State"
                                                aria-describedby="input-live-feedback-L45"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L45"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                               
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L45HCDetails')">
                                            <label for="L45HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L45HC") }}</label>
                                            <b-form-input 
                                                id="L45HC"
                                                style="font-size:16px;" 
                                                v-model="L45HC"  
                                                type="number" 
                                                :state="L45HCState"
                                                aria-describedby="input-live-feedback-L45HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L45HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}`}}</b-form-invalid-feedback>                               
                                        </div>
                                    </div> 
                                    <div class="col-sm-1 mt-4">
                                        <button class="btn btn-primary btn-block" style="font-size:20px" type="button" @click="handleSave">{{ $t('container.save') }}</button>
                                    </div>        
                                    <div class="col-sm-1 mt-4">
                                        <button class="btn btn-danger btn-block" style="font-size:20px" type="button btn-danger" @click="clickCancelProcess">{{ $t('matchTx.cancel') }}</button>
                                    </div>               
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div v-show="process === 'update' " class="row">
                    <div class="col-sm-12 gradient-ow">
                        <div class="row col-sm-8 mx-1">
                            <div class="row ml-3" v-b-hover="handleHover">
                                <h3 class="text-primary mt-3">{{ $t('freight.edit') }}</h3>
                                <span class="text-danger" style="font-size: 30px; font-weight: bold; cursor: pointer" @click="clickCancelProcess">&times;</span>
                                <span v-show="isHovered" class="text-danger">{{ $t('freight.cancelReturn')  }} </span>
                            </div> 
                            <div class="row ml-5">
                                <h3 class="mt-4 text-dark">{{ $t('bookingId.agent') }} :</h3>
                                <h3 class="mt-4 ml-2 text-info"> {{ this.selectedAgent }}</h3>
                            </div>                           
                        </div>
                        <form class="theme-form">
                            <div class="ml-2"> 
                                <div class="row col-sm-12">
                                    <div class="col-sm-1">
                                        <label for="selectedFghtCat" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("freight.fghtCat") }}</label>                                                                       
                                        <b-form-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedFghtCat" 
                                            :options="fghtOptions" 
                                            disabled
                                        >                            
                                        </b-form-select>
                                    </div> 
                                    <div class="col-sm-2" role="group">
                                        <label for="sctCode" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{$t("freight.sctCode") }}</label>
                                        <b-form-input
                                            id="sctCode"
                                            style="font-size:16px;" 
                                            v-model="sctCode"
                                            type="text"
                                            :formatter="formatter"
                                            aria-describedby="input-live-help-sctCode"
                                            :placeholder="$t('freight.sctCodePh')"
                                            disabled
                                        >
                                        </b-form-input>
                                        <b-form-text id="input-live-help-sctCode">{{ $t("freight.sctCodeHelp") }}</b-form-text>           
                                    </div>  
                                    <div class="col-sm-1 mt-1">
                                        <label for="effDate" class="f-w-600 text-primary" style="font-size: 16px">{{ $t("freight.effDate") }}</label>
                                        <datepicker input-class="datepicker-here form-control digits bg-warning" :format="format" v-model="effDate" ></datepicker>
                                    </div>  
                                    <div class="col-sm-1 mt-1">
                                        <label for="expDate" class="f-w-600 text-primary" style="font-size: 16px">{{ $t("freight.expDate") }}</label>
                                        <datepicker input-class="datepicker-here form-control digits  bg-warning"  :disabled-dates="disabledDates"  :format="format" v-model="expDate" ></datepicker>
                                    </div>
    
                                    <div class="col-sm-3">
                                        <label for="selectedPOL" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("getQuote.POL") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedPOL" 
                                            :reduce="text => text.value"
                                            label = 'text'
                                            :options="POLList" 
                                            :placeholder="$t('surcharge.plsSelect')"
                                        >                            
                                        </v-select>
                                    </div> 
                                    <div class="col-sm-3">
                                        <label for="selectedPOD" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("getQuote.POD") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedPOD" 
                                            :reduce="text => text.value"
                                            label = 'text'
                                            :options="PODList" 
                                            :placeholder="$t('surcharge.plsSelect')"
                                        >                            
                                        </v-select>
                                    </div>                             
                                </div>
                                <div class="row col-sm-12 mt-2">
                                    <div class="row mx-1 col-sm-1 ">
                                        <label for="selectedCurrency" class="col-form-label pt-0 f-w-600" style="font-size:16px;"> {{ $t("freight.currency") }}</label>                                                                       
                                        <v-select 
                                            class="style-chooser" 
                                            style="font-size:16px;" 
                                            v-model="selectedCurr" 
                                            :options="currencies" 
                                        >                            
                                        </v-select>                                        
                                    </div>
                                    <div class="row mx-3">
                                        <div role="group" v-b-popover.hover.top="$t('freight.L20Details')">
                                            <label for="L20" class="col-form-label pt-0 f-w-600">{{$t("freight.L20") }}</label>
                                            <b-form-input 
                                                id="L20"
                                                style="font-size:16px;" 
                                                v-model="L20"  
                                                type="number" 
                                                :state="L20State"
                                                aria-describedby="input-live-feedback-L20"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L20"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}`}}</b-form-invalid-feedback>                      
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40Details')">
                                            <label for="L40" class="col-form-label pt-0 f-w-600">{{$t("freight.L40") }}</label>
                                            <b-form-input 
                                                id="L40"
                                                style="font-size:16px;" 
                                                v-model="L40"  
                                                type="number" 
                                                :state="L40State"
                                                aria-describedby="input-live-feedback-L40"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40"> {{ $t("freight.fght10000Allow") }}</b-form-invalid-feedback>                             
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40HCDetails')">
                                            <label for="L40HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L40HC") }}</label>
                                            <b-form-input 
                                                id="L40HC"
                                                style="font-size:16px;" 
                                                v-model="L40HC"  
                                                type="number" 
                                                :state="L40HCState"
                                                aria-describedby="input-live-feedback-L40HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}`}}</b-form-invalid-feedback>                     
                                        </div>
                                    </div>
                                    <div class="row mx-3">
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40HRDetails')">
                                            <label for="L40HR" class="col-form-label pt-0 f-w-600">{{$t("freight.L40HR") }}</label>
                                            <b-form-input 
                                                id="L40HR"
                                                style="font-size:16px;" 
                                                v-model="L40HR"  
                                                type="number" 
                                                :state="L40HRState"
                                                aria-describedby="input-live-feedback-L40HR"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40HR"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}`}}</b-form-invalid-feedback>                              
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L40NORDetails')">
                                            <label for="L40NOR" class="col-form-label pt-0 f-w-600">{{$t("freight.L40NOR") }}</label>
                                            <b-form-input 
                                                id="L40NOR"
                                                style="font-size:16px;" 
                                                v-model="L40NOR"  
                                                type="number" 
                                                :state="L40NORState"
                                                aria-describedby="input-live-feedback-L40NOR"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L40NOR"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}`}}</b-form-invalid-feedback>                               
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L20NORDetails')">
                                            <label for="L20NOR" class="col-form-label pt-0 f-w-600">{{$t("freight.L20NOR") }}</label>
                                            <b-form-input 
                                                id="L20NOR"
                                                style="font-size:16px;" 
                                                v-model="L20NOR"  
                                                type="number" 
                                                :state="L20NORState"
                                                aria-describedby="input-live-feedback-L20NOR"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L20NOR"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                               
                                        </div>
                                    </div> 
                                    <div class="row mx-3">
                                        <div role="group" v-b-popover.hover.top="$t('freight.L20HCDetails')">
                                            <label for="L20HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L20HC") }}</label>
                                            <b-form-input 
                                                id="L20HC"
                                                style="font-size:16px;" 
                                                v-model="L20HC"  
                                                type="number" 
                                                :state="L20HCState"
                                                aria-describedby="input-live-feedback-L20HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L20HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                              
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L45Details')">
                                            <label for="L45" class="col-form-label pt-0 f-w-600">{{$t("freight.L45") }}</label>
                                            <b-form-input 
                                                id="L45"
                                                style="font-size:16px;" 
                                                v-model="L45"  
                                                type="number" 
                                                :state="L45State"
                                                aria-describedby="input-live-feedback-L45"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L45"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}` }}</b-form-invalid-feedback>                               
                                        </div>
                                        <div role="group" v-b-popover.hover.top="$t('freight.L45HCDetails')">
                                            <label for="L45HC" class="col-form-label pt-0 f-w-600">{{$t("freight.L45HC") }}</label>
                                            <b-form-input 
                                                id="L45HC"
                                                style="font-size:16px;" 
                                                v-model="L45HC"  
                                                type="number" 
                                                :state="L45HCState"
                                                aria-describedby="input-live-feedback-L45HC"
                                                min="0"
                                                max="10000"  
                                            >
                                            </b-form-input>
                                            <b-form-invalid-feedback id="input-live-feedback-L45HC"> {{ `${$t("freight.maxAllow")} :${selectedCurr} ${rateMaxAllow}`}}</b-form-invalid-feedback>                               
                                        </div>
                                    </div> 
                                    <div class="col-sm-1 mt-4">
                                        <button class="btn btn-warning btn-block" style="font-size:20px"  type="button" @click="handleUpdate">{{ $t('container.update') }}</button>
                                    </div>  
                                    <div class="col-sm-1 mt-4">
                                        <button class="btn btn-danger btn-block" style="font-size:20px"  type="button" @click="clickCancelProcess">{{ $t('matchTx.cancel') }}</button>
                                    </div>                                
                                </div>
                            </div>
                        </form>
                    </div>
                </div>                
                <div class="divider"> </div>                    
                <div class="row">
                    <h2 class="ml-4 mt-5 f-w-600">{{ $t('freight.fghtList') }}</h2>
                    <h2 class="mx-4 mt-5 f-w-600 text-danger"> :: </h2> 
                    <div class="col-sm-2 row gradient-wg">
                        <label for="selectedAgent" class="col-form-label pt-0 f-w-600" style="font-size:18px;"> {{ $t("freight.agentFreight") }}</label>                                                                       
                        <v-select 
                            class="style-chooser text-primary" 
                            style="font-size:18px;" 
                            v-model="selectedAgent" 
                            :options="agentList" 
                            @input="trigFghtListByAgent"
                            :placeholder="$t('surcharge.plsSelect')"
                        >                                
                        </v-select>
                    </div>
                    <b-button size="sm" variant="primary" :disabled="!selectedAgent" @click="selectedAgent = ''" class="mt-5 ml-3">
                        {{ $t('matchTx.clear') }}
                    </b-button>                    
                    <h2 class="mx-2 mt-5 f-w-600 text-danger"> :: </h2> 
                    <b-button v-show="process === 'info'" pill href="#addFght" size="sm" @click="clickAddFght" class="bg-primary mt-5 ml-3 ">
                        <span class="f-w-600 text-white" style="font-size: 20px;">{{ $t('freight.add') }} </span>
                    </b-button>                         
                </div>
                <div class="row mt-3">    
                    <b-col lg="4">
                        <b-form-group
                        :label="$t('matchTx.filter')"
                        label-for="filter-input"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-input
                            id="filter-input"
                            v-model="filter"
                            type="search"
                            :placeholder="$t('matchTx.typeToSearch')"
                            class="text-info"
                            style="font-size: 18px;"
                            ></b-form-input>
                            <b-input-group-append>
                            <b-button size="md" variant="primary" :disabled="!filter" @click="filter = ''">
                                {{ $t('matchTx.clear') }}
                            </b-button>
                            </b-input-group-append>
                        </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="5" >
                        <b-form-group
                        v-model="sortDirection"
                        :label="$t('matchTx.filterOn')"
                        :description= "$t('matchTx.uncheck')"
                        label-cols-sm="3"
                        label-align-sm="right"
                        label-size="lg"
                        class="mb-0"
                        v-slot="{ ariaDescribedby }"
                        >
                        <b-form-checkbox-group
                            v-model="filterOn"
                            :aria-describedby="ariaDescribedby"
                            class="text-info"
                            plain
                        >
                            <!-- <b-form-checkbox value="agent">{{ $t('bookingId.agent') }}</b-form-checkbox>                                                                 -->
                            <b-form-checkbox value="fghtCat">{{ $t('freight.fghtCat') }}</b-form-checkbox>
                            <b-form-checkbox value="fghtId">{{ $t('freight.fghtId') }}</b-form-checkbox>                               
                            <b-form-checkbox value="POL">{{ $t('getQuote.POL') }}</b-form-checkbox>   
                            <b-form-checkbox value="POD">{{ $t('getQuote.POD') }}</b-form-checkbox>   
                        </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>   
                </div>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="white"
                    show-empty
                    sort-icon-left
                    stacked="md"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync= "sortDesc"
                    :sort-direction="sortDirection"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :items="items"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @filtered="onFiltered"
                >
                    <!-- A virtual column -->
                    <template #cell(index)="data">
                        {{ data.index + 1 }}
                    </template>
                    <template #cell(detailsPOL)="row" >
                        <b-button size="sm" @click="openModalDetailsPOL(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('freight.detailsPort')">
                            {{ row.item.POL}}
                        </b-button>
                    </template>
                    <template #cell(detailsPOD)="row" >
                        <b-button size="sm" @click="openModalDetailsPOD(row.item, row.index, $event.target )" variant="outline-dark" v-b-popover.hover.top="$t('freight.detailsPort')">
                            {{ row.item.POD}}
                        </b-button>
                    </template>
                    <template #cell(actions)="row" >
                        <b-button pill size="sm" @click="actUpdate(row.item)" class="m-1 btn-warning">
                           <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.update') }}</span>
                        </b-button>
                        <b-button pill size="sm" @click="actDelete(row.item)" class="m-1 btn-danger">
                            <span class="f-w-600" style="font-size: 16px;"> {{ $t('container.delete') }}</span>
                        </b-button>                        
                    </template>
                    <template #empty>
                        <h3 class="text-danger">{{ $t('freight.noRecord') }}</h3>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPage"
                            :options="pageOptions"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
            </div>
            <b-modal id="detailsPortModal" :title="$t('freight.detailsPort')" size="md" ok-only @hide="resetModalDetailsPort">
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('port.portId') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{this.portId }}</h3>
                </div>   
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('port.pName') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{this.pName }}</h3>
                </div>                
                <div class="row ml-2">
                    <h3 class="mt-3"> {{ $t('port.cntry') }} :</h3>
                    <h3 class="mt-3 ml-2 text-info"> {{ this.cntry }}</h3>
                </div>
            </b-modal>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>
import { vSelectObjPort ,agentList, getFghtRates ,getData,saveWithId, compNameEngByCompId, deleteItem, getPortList, getAllPortsList} from "../../firebase"
import {currencies, inputLimitUSD} from '../../constants/config'

export default {
	data(){
		return{
            compId : '',
            compName : '',
            process : "info",
            isHovered: false,
            selectedFghtCat : 'FAK',
            fghtOptions : ['FAK',"NAC"],
            fghtId : '',
            sctCode : "",
            effDate : '',
            expDate : '',
            format: "yyyy-MM-dd",
            portId : '',
            pName : '',
            cntry : '',
            disabledDates: {
                to: new Date(Date.parse(new Date())-86400000),
            },
            selectedAgent : "",                     
            agentList : [],  
            selectedPOL : '',               
            POLList : [],     
            selectedPOD : '',       
            PODList : [],
            PODList2 : [
                'foo',
                'bar',
                'dad'
            ],
            currencies : currencies,
            selectedCurr : 'USD',
            rateMaxAllow : 10000 ,
            L20 : 0,
            L40 : 0,
            L40HC : 0,
            L40HR : 0,
            L40NOR :0,
            L20NOR :0,
            L20HC : 0,   
            L45 : 0,
            L45HC : 0,         
            items: [],
            fields: [
                { key: 'index', label: this.$t('seal.item'), sortable: true , variant: 'info'},     
                { key: 'fghtCat', label: this.$t('freight.cat'), sortable: true , variant: 'info'},                   
                { key: 'fghtId', label: this.$t('freight.fghtId'), sortable: true, variant: 'info'},  
                { key: 'sctCode', label: this.$t('freight.sctCode'), sortable: true , variant: 'info'},  
                { key: 'effDateTS', label: this.$t('freight.effDate'), sortable: true , variant: 'info', 
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }},                
                { key: 'expDateTS', label: this.$t('freight.expDate'), sortable: true , variant: 'info', 
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }},                                          
                { key: 'detailsPOL', label: this.$t('getQuote.POL'), sortable: true , variant: 'info'},  
                { key: 'detailsPOD', label: this.$t('getQuote.POD'), sortable: true , variant: 'info'}, 
                { key: 'curr', label: this.$t('freight.currency'), variant: 'success' },   
                { key: 'L20', label: this.$t('freight.L20'), variant: 'success' }, 
                { key: 'L40', label: this.$t('freight.L40'),variant: 'success' },  
                { key: 'L40HC', label: this.$t('freight.L40HC'), variant: 'success'},  
                { key: 'L40HR', label: this.$t('freight.L40HR'),  variant: 'secondary'},  
                { key: 'L40NOR', label: this.$t('freight.L40NOR'), variant: 'secondary'},  
                { key: 'L20NOR', label: this.$t('freight.L20NOR'), variant: 'secondary'},  
                { key: 'L20HC', label: this.$t('freight.L20HC'), variant: 'secondary'},  
                { key: 'L45', label: this.$t('freight.L45'),variant: 'secondary' },  
                { key: 'L45HC', label: this.$t('freight.L45HC'), variant: 'secondary'},  
                { key: 'actions', label: this.$t('matchTx.actions'), variant: 'warning'},
                { key: 'ts', label: this.$t('driver.recordAt'), sortable: true , variant: 'info', 
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }}, 
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'ts',
            sortDesc: true,
            sortDirection: 'desc',
            filter: null,
            filterOn: [],
		}
	},
    computed: {
        sortOptions() {
            return this.fields
            .filter(f => f.sortable)
            .map(f => {
                return { text: f.label, value: f.key }
            })
        },

        L20State() {
           this.rateSwitch()
            return this.L20 <= this.rateMaxAllow ? true : false
        },       
        L40State() {
            this.rateSwitch()
            return this.L40 <= this.rateMaxAllow? true : false
        }, 
        L40HCState() {
            this.rateSwitch()
            return this.L40HC <= this.rateMaxAllow ? true : false
        }, 
        L40HRState() {
            this.rateSwitch()
            return this.L40HR <= this.rateMaxAllow ? true : false
        },        
        L40NORState() {
            this.rateSwitch()
            return this.L40NOR <= this.rateMaxAllow ? true : false
        },
        L20NORState() {
            this.rateSwitch()
            return this.L20NOR <= this.rateMaxAllow ? true : false
        },
        L20HCState() {
            this.rateSwitch()
            return this.L20HC <= this.rateMaxAllow ? true : false
        }, 
        L45State() {
            this.rateSwitch()
            return this.L45 <= this.rateMaxAllow? true : false
        }, 
        L45HCState() {
            this.rateSwitch()
            return this.L45HC <= this.rateMaxAllow ? true : false
        }, 
    },
	mounted(){
        this.compId= localStorage.getItem("compId")
        compNameEngByCompId (this.compId, (res)=>{
            this.compName =res
        })
        agentList((res)=>{
            this.agentList = res.sort()
        })
        getPortList( "TH", (res)=>{
            this.POLList = res
        })

        getAllPortsList((res)=>{
            this.PODList = res
        })
	},
	methods:{
        rateSwitch(){
            switch (this.selectedCurr) {
                case 'USD':
                    this.rateMaxAllow = inputLimitUSD
                    break;
                case 'EUR':
                    this.rateMaxAllow = inputLimitUSD * 0.86
                break;
                case 'JPY':
                    this.rateMaxAllow = inputLimitUSD * 150
                    break;
                case 'GBP':
                    this.rateMaxAllow = inputLimitUSD * 0.75
                break;
                case 'CNY':
                    this.rateMaxAllow = inputLimitUSD * 7.13
                break;
                case 'AUD':
                    this.rateMaxAllow = inputLimitUSD * 1.54
                    break;
                case 'CAD':
                    this.rateMaxAllow = inputLimitUSD * 1.4
                break;
                default:
                    break;
            }
        },
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },        
        handleHover(hovered) {
            this.isHovered = hovered
        },
        formatter(value) {
            return value.toUpperCase()
        },
        clickCancelProcess(){
            this.process = 'info'
            this.refresh()
        },
        async trigFghtListByAgent( value){
            if (value) {
                // await getFghtRates( this.compId, this.selectedAgent, async(res)=>{
                //     this.items = res 
                //     this.totalRows = res.length
                // })
                this.refresh()
            } 
            else {
                this.items = []
                this.totalRows = 0
                this.$toasted.show(this.$t('bookingId.selAgent'), {theme: 'bubble', type: 'info' , position: 'bottom-center', duration: 5000}); 
            }
        },
        clickAddFght() {
            if (this.selectedAgent != '') {
                this.process = 'add'
            } else {
                this.$bvModal.msgBoxConfirm(this.$t('freight.selAgent'), {
                title: this.$t('bookingId.selAgent'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'warning',
                okTitle: this.$t('matchTx.yes'),
                // cancelTitle: this.$t('matchTx.no'),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
                })
                .then(async(value) => {
                    if (value) {
                        this.process = 'info'
                    } else {
                        return
                    }
                })
                .catch(error => {
                    this.$toasted.show( `Click add freight: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                })
            }
         
        },   

        async handleSave(){
            let msg = 'completed'
            if (this.selectedAgent ==='') {
                msg = 'bookingId.selAgent'
            } else if (this.selectedFghtCat ===''){
                msg = 'freight.selFghtCat'
            } else if (this.sctCode ===''){
                msg = 'freight.addSctCode'
            } else if (this.effDate ===''){
                msg = 'freight.addEffDate'
            } else if (this.expDate ===''){
                msg = 'freight.addExpDate'
            } else if (Date.parse(this.expDate) < Date.parse(this.effDate)){
                msg = 'freight.expDateMoreThanEffDate'
            } else if (this.selectedPOL === ''){
                msg = 'getQuote.POLPh'
            } else if (this.selectedPOD === ''){
                msg = 'getQuote.PODPh'
            } else if (this.L20 == 0){
                msg = 'freight.addL20'
            } else if (this.L40== 0){
                msg = 'freight.addL40'
            } else if (this.L40HC == 0){
                msg = 'freight.addL40HC'
            } 
            if (msg === 'completed'){  
                let fghtId = `${this.selectedAgent.slice(0,3).trim()}-${this.sctCode.trim()}-${this.compName.slice(0,5).toUpperCase().trim()}-${this.selectedFghtCat.slice(0,3).trim()}-${this.selectedPOL}${this.$moment(this.effDate).format("YYMMDD")}${this.selectedPOD}`
                await getData('FreightRate', 'fghtId', fghtId, async(res)=>{
                    if (res.length == 0 ) {
                        await this.saveFght(fghtId).then(async()=>{
                            await this.refreshAdd()
                        })  
                    } else {
                       await this.confirmSaveFght(fghtId) 
                    }
                } ) 
            } else {
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },

        async saveFght(fghtId){
            let mExpDate = this.$moment(this.expDate).format("YYYY-MM-DD")            
            let payload = {
                compId : this.compId,
                fghtCat :this.selectedFghtCat,
                fghtId : fghtId,
                sctCode : this.sctCode,
                effDateTS : Date.parse(this.effDate),
                expDateTS : Date.parse(mExpDate + ' ' + '23:59:59'),
                agent : this.selectedAgent,                     
                POL : this.selectedPOL,                  
                POD : this.selectedPOD,
                curr : this.selectedCurr,    
                L20 : this.L20,
                L40 :this.L40,
                L40HC : this.L40HC,
                L40HR : this.L40HR,
                L40NOR : this.L40NOR,
                L20NOR : this.L20NOR,  
                L20HC : this.L20HC,   
                L45 :this.L45,
                L45HC : this.L45HC,              
                ts : Date.parse(new Date())
            }
            await saveWithId('FreightRate', fghtId, payload).then(async()=>{
                this.$toasted.show(this.$t('reuse.successSave'), {theme: 'bubble', position: 'bottom-center', type: 'success' , duration: 5000});                                                    
            })
        },

        async confirmSaveFght(fghtId) {
            this.$bvModal.msgBoxConfirm(this.$t('freight.confirmSaveFreightMsg'), {
            title: this.$t('freight.plsConfirmOverwrite'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await this.saveFght(fghtId).then(async()=>{
                    await this.refreshAdd()
                 })                
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },  
        async actDelete(item) {
            this.$bvModal.msgBoxConfirm(this.$t('container.confirmDeleteMsg'), {
            title: this.$t('matchTx.plsConfirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'warning',
            okTitle: this.$t('matchTx.yes'),
            cancelTitle: this.$t('matchTx.no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
            })
            .then(async(value) => {
                if (value) {
                    await deleteItem( "FreightRate", item.fghtId)
                    await this.refresh()                   
                    this.$toasted.show( this.$t('container.deleted'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Delete: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
            })
        },    
        async refreshAdd(){
            await getFghtRates( this.compId, this.selectedAgent,(res)=>{
                this.items = res
                this.totalRows = res.length
            })
            this.fghtId = ''
            // this.selectedFghtCat = 'FAK'
            // this.sctCode = ""
            // this.effDate = ''
            // this.expDate = ''              
            // this.selectedPOL = ''             
            this.selectedPOD = ''    
            // this.L20 = 0
            // this.L40 = 0
            // this.L40HC = 0
            // this.L40HR = 0
            // this.L40NOR = 0
            // this.L20NOR = 0   
            // this.L20HC = 0
            // this.L45 = 0
            // this.L45HC = 0         
            // this.process = 'info'
        },
        async refresh(){
            await getFghtRates( this.compId, this.selectedAgent,(res)=>{
                this.items = res
                this.totalRows = res.length
            })
            this.fghtId = ''
            this.selectedFghtCat = 'FAK'
            this.sctCode = ""
            this.effDate = ''
            this.expDate = ''              
            this.selectedPOL = ''             
            this.selectedPOD = ''
            this.selectedCurr = 'USD'  
            this.L20 = 0
            this.L40 = 0
            this.L40HC = 0
            this.L40HR = 0
            this.L40NOR = 0
            this.L20NOR = 0 
            this.L20HC = 0
            this.L45 = 0
            this.L45HC = 0              
            this.process = 'info'
        },
        async handleUpdate(){
            let msg = 'completed'
            if (this.selectedFghtCat ==='') {
                msg = 'freight.selFghtCat'
            } else if (this.sctCode ===''){
                msg = 'freight.addSctCode'
            } else if (this.effDate ===''){
                msg = 'freight.addEffDate'
            } else if (this.expDate ===''){
                msg = 'freight.addExpDate'
            } else if (Date.parse(this.expDate) < Date.parse(this.effDate)){
                msg = 'freight.expDateMoreThanEffDate'
            } else if (this.selectedPOL === ''){
                msg = 'getQuote.POLPh'
            } else if (this.selectedPOD === ''){
                msg = 'getQuote.PODPh'
            } else if (this.L20 == 0){
                msg = 'freight.addL20'
            } else if (this.L40 == 0){
                msg = 'freight.addL40'
            } else if (this.L40HC == 0){
                msg = 'freight.addL40HC'
            } 
            if (msg === 'completed'){
                await this.saveFght(this.fghtId).then(async()=>{
                    await this.refresh()
                })
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },

        async actUpdate(item) {
            this.process = "update"   // to pop up Update subMenu
            this.fghtId = item.fghtId
            this.selectedAgent = item.agent
            this.selectedFghtCat = item.fghtCat
            this.sctCode = item.sctCode
            this.effDate = this.$moment(item.effDateTS).format("YYYY-MM-DD")
            this.expDate = this.$moment(item.expDateTS).format("YYYY-MM-DD")              
            // this.selectedPOL = vSelectObjPort(item.POL )           
            // this.selectedPOD = vSelectObjPort(item.POD )  
            this.selectedPOL = item.POL           
            this.selectedPOD = item.POD  
            this.selectedCurr = item.curr
            this.L20 = item.L20
            this.L40 = item.L40
            this.L40HC = item.L40HC
            this.L40HR = item.L40HR
            this.L40NOR = item.L40NOR
            this.L20NOR = item.L20NOR     
            this.L20HC = item.L20HC
            this.L45 = item.L45
            this.L45HC = item.L45HC       
        }, 
        async openModalDetailsPOL(item, index, button) {
          await getData( 'Port' ,'id' , item.POL, (res)=>{
            this.portId = res[0].id
            this.pName = res[0].pName.trim()
            this.cntry = res[0].cntry
          })
          this.$root.$emit('bv::show::modal', "detailsPortModal" , button)
        },
        async openModalDetailsPOD(item, index, button) {
          await getData( 'Port' ,'id' , item.POD, (res)=>{
            this.portId = res[0].id
            this.pName = res[0].pName.trim()
            this.cntry = res[0].cntry
          })
          this.$root.$emit('bv::show::modal', "detailsPortModal" , button)
        },
        resetModalDetailsPort() {
            this.portId = ''
            this.pName = ''
            this.cntry = ''
        },
    }
}
</script>
<style scoped>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dffbf9;
  border: none;
  color: #394066;
  text-transform: uppercase;
  font-variant: small-caps;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
 .gradient-ow {
   background: linear-gradient(135deg, orange, white);
 }
 .gradient-wg {
   background: linear-gradient(135deg, white, green);
 }

.divider {
    height: 5px;
    background-color: #f10909;
    margin:5px
}
</style>
